import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { knownZone } from '../utils/liveCalendar';

/** The last zone read per person, so every row after the first renders in it. */
const cache = new Map<string, string>();

function deviceZone(): string {
  const device = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return knownZone(device) ? device : 'America/New_York';
}

/**
 * The signed-in person's confirmed zone (users.timeZone, spec 12), else the
 * device's. Read from the user document: the profile loaded at sign in
 * does not carry it.
 */
export function useViewerZone(): string {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [zone, setZone] = useState(() => (uid && cache.get(uid)) || deviceZone());
  useEffect(() => {
    if (!uid) return;
    return onSnapshot(doc(db, 'users', uid), (snap) => {
      const tz = snap.data()?.timeZone;
      if (knownZone(tz)) { cache.set(uid, tz); setZone(tz); }
    }, () => { /* the device's zone */ });
  }, [uid]);
  return zone;
}
